module.exports = Backbone.View.extend({
	template: require('./sprint-view-template'),
	className: 'sprint',

	afterRender: function() {
		App.stopLoad()
	}
})
